import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { ButtonModule } from "primeng/button";
import { TooltipModule } from "primeng/tooltip";

import { IconModule } from "../icon/icon.module";

@Component({
	selector: "ic-account-menu",
	imports: [IconModule, ButtonModule, TooltipModule, TranslateModule],
	templateUrl: "./account-menu.component.html",
	styleUrl: "./account-menu.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountMenuComponent {
	private readonly router = inject(Router);
	private readonly route = inject(ActivatedRoute);

	userDisplayName = input.required<string>();
	userMainFunction = input.required<string>();

	protected logOut(): void {
		this.route.root.firstChild?.paramMap.subscribe((params) => {
			this.router.navigate(
				params.get("home") ? [params.get("org"), params.get("home"), "log-out"] : [params.get("org"), "log-out"],
			);
		});
	}
}
